// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-fluid[data-v-46f7ad05] {\n    max-width: 1200px;\n    margin-left: 0;\n}\n.col-form-label[data-v-46f7ad05] {\n    width: 100px;\n}", ""]);
// Exports
module.exports = exports;
